import React, { Component } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { get } from 'lodash';

const getItemStyle = (draggableStyle) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  userSelect: 'none',
  padding: '5px',
  margin: '0 0 5px 0',
  background: 'white',
  border: 'solid lightgray 1px',
  ...draggableStyle,
});

const styles = {
  info: {
    marginLeft: '20px',
  },
  number: {
    color: 'gray',
  },
  target: {
    fontSize: '12px',
  },
  remove: {
    padding: 0,
    marginLeft: 'auto',
    float: 'right',
    height: '18px',
    width: '18px',
  },
  close: {
    width: '16px',
    height: '16px',
  },
  name: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '180px',
    textOverflow: 'ellipsis',
  },
};

export default function DragListItem({ location, index, handleRemove }) {
  return (
    <Draggable draggableId={location._id} index={index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={getItemStyle(provided.draggableProps.style)}
        >
          <Typography style={styles.number}>
            #
            {index + 1}
          </Typography>
          <div style={styles.info}>
            <Typography style={styles.name}><strong>{location.name}</strong></Typography>
            <Typography style={styles.target}>{`Target: ${get(location, 'targetVehicleCounts.link', 0)}`}</Typography>
          </div>
          <IconButton size="small" onClick={() => handleRemove(index)} style={styles.remove}>
            <CloseIcon style={styles.close} />
          </IconButton>
        </div>
      )}
    </Draggable>
  );
}
